// frontend/src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router.js'
import axios from 'axios'
import './assets/tailwind.css'

const API_BASE_URL = process.env.VUE_APP_API_URL || '/api';

// Esto es un "interceptor": se ejecuta antes de CADA petición de axios
axios.interceptors.request.use(config => {
  const token = sessionStorage.getItem('accessToken');
  
  // Si el token existe, lo añade a la cabecera Authorization
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

let isRefreshing = false; // Flag para prevenir bucles infinitos
let failedQueue = [];     // Cola de peticiones fallidas

// Función para procesar la cola de peticiones fallidas
const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};


// 2. Interceptor de RESPUESTA (Detecta tokens expirados)
axios.interceptors.response.use(response => response, async (error) => {
    const originalRequest = error.config;
    
    // PROTECCIÓN 1: Si no hay respuesta (servidor caído/502), rechazamos directamente
    if (!error.response) {
        return Promise.reject(error);
    }

    // Si el error no es 401 o ya se reintentó
    if (error.response.status !== 401 || originalRequest._retry) {
        return Promise.reject(error);
    }
    
    if (error.response.data.code === 'token_not_valid' && !isRefreshing) {
        isRefreshing = true;
        originalRequest._retry = true;
        
        // CAMBIO: Usar sessionStorage
        const refreshToken = sessionStorage.getItem('refreshToken');
        
        if (!refreshToken) {
            sessionStorage.removeItem('accessToken');
            router.push('/login'); // Redirigir
            return Promise.reject(error); 
        }

        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(`${API_BASE_URL}/token/refresh/`, {
                    refresh: refreshToken
                });
                const newAccessToken = response.data.access;
                
                // CAMBIO: Usar sessionStorage
                sessionStorage.setItem('accessToken', newAccessToken);
                originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                
                processQueue(null, newAccessToken); 
                resolve(axios(originalRequest));
            } catch (_error) {
                // CAMBIO: Usar sessionStorage y redirigir
                sessionStorage.removeItem('accessToken');
                sessionStorage.removeItem('refreshToken');
                processQueue(_error, null);
                router.push('/login'); 
                reject(_error);
            } finally {
                isRefreshing = false;
            }
        });
    }

    // Si la petición falla mientras el token se refresca (está en la cola)
    if (isRefreshing) {
        return new Promise(function(resolve, reject) {
            failedQueue.push({ resolve, reject });
        }).then(token => {
            originalRequest.headers['Authorization'] = `Bearer ${token}`;
            return axios(originalRequest);
        }).catch(err => {
            return Promise.reject(err);
        });
    }
    
    return Promise.reject(error);
});

// 3. Crea la app, usa el router, y móntala
createApp(App).use(router).mount('#app')